import * as React from 'react'
import { Button } from '~/components/_atoms/index'
import { useTranslation } from '~/hooks/useTranslation'

export function DownloadCell({ row }) {
  const chat = row.original

  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="flex flex-row items-center gap-1 text-sm">
        <div className="flex flex-col">
          <Button
            variant="link"
            href={`/chat_histories/${chat.id}/download_chat_conversation?format=pdf`}
            target="_blank"
          >
            {t('chat_histories.download')}
          </Button>
        </div>
      </div>
    </div>
  )
}
